import React, { ReactElement } from 'react';
import TableRow from '../../../components/table-row/table-row.component';
import TableCell from '../../../components/table-cell/table-cell.component';
import TableCellShort from '../../../components/table-cell-short/table-cell-short.component';

const SearchResultRow: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSubItem,
    searchResultItem,
    tableSearchResultColumnList,
    onClick,
  } = props;

  return (
    <TableRow
      isButton
      isActive={isSubItem}
      onClick={(): void => {
        if (onClick) {
          onClick(searchResultItem.id, searchResultItem.dealId || null);
        }
      }}
    >
      {
        tableSearchResultColumnList.map((searchColumnItem: SearchColumnItem): ReactElement => {
          const component: ReactElement = searchColumnItem.component
            ? searchColumnItem.component(searchResultItem)
            : (searchColumnItem.field && searchResultItem[searchColumnItem.field]);

          return searchColumnItem.isImage ? (
            <TableCellShort isTextCenter key={searchColumnItem.id}>
              {component}
            </TableCellShort>
          ) : (
            <TableCell isTextMultiline={searchColumnItem.isMultiline} key={searchColumnItem.id}>
              {component}
            </TableCell>
          );
        })
      }
    </TableRow>
  );
});

export default SearchResultRow;
